export const InviteStatus = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
};

export const RelationStatus = {
  REMOVED: 'REMOVED',
};
